import React,{useState} from 'react';



export default function TextArea(props) {
    const handleUpClick = ()=>{
        let newText= Text.toUpperCase();
        setText(newText)
        props.showAlert("Text converted to upper case","success");
    }

    const handleLoClick = ()=>{
      let newText= Text.toLowerCase();
      setText(newText)
      props.showAlert("Text converted to lower case","success");

  }
    const handleClear= ()=>{
      let newText= '';
      setText(newText)
  }
    const handleOnChange = (event)=>{
        console.log('On change')
        setText(event.target.value )

    }
    const handleCopy = ()=>{
      var text=document.getElementById("mybox");
      text.select();
      navigator.clipboard.writeText(text.value);
      props.showAlert("Text copied","success");

    }
    const handleSpaces =()=>{
      let newText=Text.split(/[ ]+/);// uses javascript Regex
      setText(newText.join(' '))
      props.showAlert("Extra spaces from text are removed","success");

    }
    const [Text, setText] = useState('');
  return (
    <>
    <div className='container my-2' style={{color: props.mode==='dark'?'white':'#151e3a'}}>   
        <div className="mb-3">
        <label htmlFor="mybox" className="form-label">
        <h1 className='mb-3'>{props.heading}</h1></label>
        <textarea className="form-control" value={Text}  onChange={handleOnChange} style={{backgroundColor: props.mode==='dark'?'#13466e':'white',color: props.mode==='dark'?'white':'#151e3a'}} id="mybox" rows="5"></textarea>
        </div>
        <button disabled={Text.length===0} className="btn btn-primary my-2 mx-1" onClick={handleUpClick}>Convert To UpperCase</button>
        <button disabled={Text.length===0} className="btn btn-primary mx-2 my-1" onClick={handleLoClick}>Convert To LowerCase</button>
        <button disabled={Text.length===0} className="btn btn-success mx-2 my-1" onClick={handleCopy}>Copy Text </button>
        <button disabled={Text.length===0} className="btn btn-success mx-2 my-1" onClick={handleSpaces}>Remove Extra Spaces</button>
        <button disabled={Text.length===0} className="btn btn-danger mx-2 my-1" onClick={handleClear}>Clear Text</button>
    </div>
    <div className="container my-3" style={{color: props.mode==='dark'?'white':'#151e3a'}}>
      <h2>Your text summery</h2>
      <p>{Text.split(" ").length-1} words and {Text.length} characters</p>
    </div>
    <div className="container my-3 " style={{color: props.mode==='dark'?'white':'#151e3a'}}>
      <h2>Preview</h2>
      <p >{Text.length>0?Text:"Enter text to preview here"}</p>
    </div>
    </>
  )
}
